import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchSettings = createAsyncThunk(
  "settings/fetchSettings",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/settings", {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Accept-Language": language || "en",
        },
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve settings"
        );
      }

      if (
        !Array.isArray(responseData.data) ||
        responseData.data.length === 0
      ) {
        return thunkApi.rejectWithValue("Settings are unavailable");
      }

      return responseData.data[0];
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  data: null,
  loading: false,
  error: "",
};

var settingsSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchSettings.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchSettings.fulfilled, function (state, action) {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSettings.rejected, function (state, action) {
        state.loading = false;
        state.error = action.payload || "Unable to retrieve settings";
      });
  },
});

export default settingsSlice.reducer;